import {Grid} from "@mui/material"
import React from "react"

const RaterAnaliseSetorial = () => {
    
    return (
        <Grid>
        </Grid>

    )
}

export default RaterAnaliseSetorial